import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import Modal from '@/components/v3/Modal.vue';
import ActiveFacebookPage from '@/plugins/graphql/queries/active-facebook-page.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
let LaunchThankYou = class LaunchThankYou extends Mixins(RouterParamsAppMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.modalOpen = false;
    }
    get thankYouPageUrl() {
        return ('https://chatgenie.ph/miniapp-launched-success?' +
            `appUuid=${this.appUUID}&bundleKey=${this.serviceBundleKey}` +
            `&fbPageId=${this.fbPageId}`);
    }
    get serviceBundleKey() {
        return this.bundleKey;
    }
    get appUUID() {
        return this.$store.state.appUUID;
    }
    get fbPageId() {
        return this.activePage.fbPageId;
    }
    mounted() {
        this.successNotification('Launch successful! Your store is live and ready for orders.');
        const delay = 3000;
        setTimeout(() => {
            this.modalOpen = true;
        }, delay);
    }
};
LaunchThankYou = __decorate([
    Component({
        apollo: {
            activePage: {
                query: ActiveFacebookPage,
                variables() {
                    return {
                        appUUID: this.appUUID,
                    };
                },
                update(data) {
                    return data.activePage;
                },
            },
        },
        components: {
            Modal,
        },
    })
], LaunchThankYou);
export default LaunchThankYou;
